import zhLocale from "element-ui/lib/locale/lang/zh-CN";

const cn = {
  message: {
    tryBtn: "点击试用",
    registerBtn: '立即注册',
    experienceBtn: "立即体验",
    enterBtn: '立即进入',
    contactBtn: "联系我们",
    contactTxt: "联系我们，开启您的全球化业务开拓数智加速之旅！",
    contactTxtMobile: "联系我们，<br/>开启您的全球化业务开拓数智加速之旅！",
    contactMobileTxtSolution: "立即申请免费试用",
    tips: "提示",
    privacyPolicy: '隐私政策',
    terms: '使用条款',
    // 登录
    login: {
      loginWelcome: "登录",
      loginTitle:
        "AI驱动领域革新， <br/>助力产品/技术服务商开启全球业务开拓新征程。",
      loginUsername: "账户",
      loginPassword: "密码",
      rememberAccount: "记住账号",
      loginTips: "还没有账户？立即注册",
      loginButton: "登录",
      loginError: "登录失败",
      // 注册
      registerWelcome: "注册",
      registerUsername: "账户",
      registerPassword: "密码",
      registerConfirmPassword: "确认密码",
      registerTips: "已有账户？立即登录",
      registerButton: "注册",
      registerError: "注册失败",
    },
    userEdit: {
      userName: "用户名",
      confirmPassword: "确认密码",
      pleaseEnter: "请输入",
      msg1: "请输入新密码",
      msg2: "密码长度为8-18位，至少包含字母、数字、符号中的两种",
      msg3: "请再次输入密码",
      msg4: "两次输入密码不一致！",
    },
    // 头部
    header: {
      docs: '用户指南',
      // 顶部导航
      navList: [
        {
          name: "产品",
          children: [
            {
              name: "AI建站",
            },
            {
              name: "AI销售开拓助手",
              children: [
                {
                  name: "市场分析",
                  desc: "多维市场洞察与风险评估",
                  children: [
                    {
                      name: "客户搜索",
                    },
                  ],
                },
                {
                  name: "全球获客",
                  desc: "精准触达全球决策人",
                },
                {
                  name: "客户洞察",
                  desc: "深度解码客户需求痛点",
                  children: [
                    {
                      name: "客户管理",
                    },
                    {
                      name: "个性化EDM",
                    },
                  ],
                },
                {
                  name: "图文海报制作",
                  desc: "一键生成多语种海报",
                },
                {
                  name: "语音同传/策略沟通助手",
                  desc: "实时翻译与谈判辅佐",
                },
                {
                  name: "智能邮件",
                  desc: "高效撰写跨文化邮件",
                },
                {
                  name: "困境策略大师",
                  desc: "破解销售困境与话术",
                },
              ],
            },
            {
              name: "AI售前支持助手",
              children: [
                {
                  name: "售前顾问支持工具",
                  children: [
                    {
                      name: "痛点挖掘专家",
                      desc: "精准定位核心痛点",
                    },
                    {
                      name: "运营模拟分析平台",
                      desc: "快速生成定制方案",
                    },
                    {
                      name: "解决方案生成平台",
                      desc: "量化预演决策效果",
                    },
                    {
                      name: "Demo及培训平台",
                      desc: "远程沉浸式产品演示",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          name: "关于我们",
        },
        {
          name: "联系我们",
        },
      ],
      stageText1: '选择销售阶段',
      stageText2: '​明确潜在市场',
      stageText3: '查找目标客户',
      stageText4: '​联系触达客户',
      stageText5: '组织会议沟通',
      stageText6: '​挖掘客户需求',
      stageText7: '​提供定制方案',
      stageText8: '​推动客户立项',
      loginBtn: "立即登录",
      loginOutBtn: "退出登录",
      loginTips: "请先登录",
      logoutTips: "确定要退出登录吗？",
      logoutSuccess: "您已退出登录",
      phone: '联系电话',
    },
    // 首页
    index: {
      banner: {
        btnText: '点击试用',
        title: "企业服务及非标品业务<br/>AI销售开拓平台",
        content: "一站式提供市场分析、全球获客、<br/>客户沟通、策略指导、售前顾问、<br/>技术支持等全流程AI销售及售前顾问工具。",
        beforeContent: '一站式提供全流程AI销售及售前顾问工具:',
        afterContent: '',
        content2: '企业服务及非标品业务AI业务开拓平台：<br/>一站式提供市场分析、全球获客、客户沟通、策略指导、售前顾问顾问、技术支持等全流程AI销售及售前顾问工具。',
        tools: [
          { text: '' },
          { text: '' },
          { text: '' },
          { text: '' },
          { text: '' },
        ],
        desc: "专为“企业服务及非标品业务”打造的一站式全球业务开拓平台！",
      },
      business: {
        title: 'Xpirory覆盖企业服务及非标品业务销售流程中超80%的业务环节',
        btnGroup: {
          btn1: '销售准备',
          btn2: '推广宣传',
          btn3: '客户开拓',
          btn4: '市场分析',
          btn5: '营销素材',
          btn6: '广告营销',
          btn7: '全球获客',
          btn8: '客户分析',
          btn9: '商务沟通',
          btn10: '售前顾问支持',
          btn11: '策略指导',
          btn12: '产品演示及培训',
          btn13: '商务活动',
          btn14: '投标及合同',
        },
      },
      tool: {
        title: '多种销售及售前顾问工具，助您高效找到市场及开拓客户',
        content: [
          {
            title: 'AI销售业务开拓助手',
            desc: '助力销售在同等时间<br>开拓数倍的客户，高效成交',
          },
          {
            title: 'AI售前顾问支持助手',
            desc: '让售前顾问支持人员打造<br>多个分身，高效服务客户',
          }
        ]
      },
      valuations: {
        title: '来自用户的反馈',
        msg1: '给俄罗斯客户设计跨境物流方案时，AI 自动分析莫斯科清关政策，生成的多币种报价单直接签单！客户开拓模块用俄语推送‘中欧班列时效对比’，本月新签10+客户！',
        msg2: '用了 AI 工具后，亚马逊选品效率直接翻倍！市场分析模块帮我们精准定位东南亚爆款，客户开拓功能自动生成多语言开发信，上周刚签了马来西亚代理商，比传统方式快了3个月！',
        msg3: '工厂转型做外贸愁坏了，AI 工具一键生成行业报告，帮我们锁定欧洲新能源设备需求。售前顾问顾问模块连客户可能问的技术参数都提前预判了，现在每天能跟进10+有效询盘！',
        msg4: '在开发越南电子厂客户时，通过平台用越南语自动搜集客户信息并做了深度分析，快速锁定了和客户的切入点，比以往自己做客户分析效率高了不止1倍。同时，使用AI模拟平台分析发现客户多个潜在优化点，前期调研沟通成本节省50%！！',
        msg5: '我真的太喜欢Xpirory的一站式业务开拓平台了，他帮助我快速的进行市场分析，市场开拓，客户开发等一些列的工作，真正提供了非常强大的帮助！',
        msg6: '之前客户一直对仓储管理方案改造效果不理解，去现场做Demo演示成本又特别高。后来我们通过远程Demo的演示让土耳其工厂的客户直观地感受到了方案应用效果，客户对技术的疑虑马上打消！项目推进周期比预期缩短至少45天！',
        msg7: '非标产品转型做外贸愁坏了，我们应该怎么找到目标市场？怎么找到对应的客户？怎么准备对应他们能理解的资料？后来我们发现Xpirory上这些问题全部都可以帮我们解决。从找市场，找客户，到客户跟进都有太多好用的工具了！',
        msg8: '利用平台的AI工具对客户进行洞察分析，并结合我们公司的业务重点，AI对EDM话术给出了详细的指导意见，比起自己去优化邮件效率提升了200%，并且指导过的邮件客户回复率增长了60%！',
        msg9: '作为 Xpirory 一站式业务开拓平台的深度用户，真的忍不住要为它打 call！从市场调研时的数据洞察，到客户开发阶段的精准触达，再到全渠道营销的高效落地，这个平台就像一位全能助手，把原本繁琐的营销流程变得清晰又高效。',
        msg10: 'Xpirory帮我们分析发现法国航空航天业客户的隐性需求，据此我们针对性地推送‘创新性的3D打印材料’方案！并且行业展会期间获得了大批客户咨询，订单转化率比以往提高了60%！',
        msg11: '以前去开拓马来西亚当地市场，我们投入了非常多的销售和售前顾问资源，现在通过Xpirory，我们轻松分析出了我们需要发力的重点区域和策略，而且直接就可以查询相关的目标客户，这让我们在海外开拓更加游刃有余了，并且节省了5成以上的差旅投入。',
        msg12: '客户对传感器部署有疑虑？通过在线实景远程Demo演示了多种场景的数据采集，英国客户当场就觉得要进行采购了！',
        msg13: '汪先生',
        msg14: '钱先生',
        msg15: '关女士',
        msg16: '王先生',
        msg17: '李先生',
        msg18: '冯先生',
        msg19: '白女士',
        msg20: '林女士',
        msg21: '跨境自动化技术输出商',
        msg22: '跨境ERP系统开发商',
        msg23: '国际物流方案集成商',
        msg24: '工业软件开发商',
        msg25: '制造业',
        msg26: '电子元件供应商',
        msg27: '金属加工设备商',
        msg28: '工业物联网服务商',
        msg29: '塑料机械制造商',
        msg30: '工业物联网服务商',
      },
      platform: {
        list: [
          {
            content: {
              title: "AI建站：把需求告诉AI，<br/>它帮你建站！",
              info: [
                {
                  title: "AI智能极速建站",
                  desc: "颠覆传统耗时的建站模式，文案、图片和排版统统交给AI处理。",
                },
                {
                  title: "内容AI智能生成",
                  desc: "AI自动撰写专业的网站宣传文案，再也不用为文案内容发愁。",
                },
                {
                  title: "零代码可视化编辑",
                  desc: "不懂代码也能按自己的想法灵活修改和更新网站内容。",
                },
                {
                  title: "一站式省心托管",
                  desc: "提供一站式的网站托管服务，你的业务今天就可以上线。",
                },
              ],
            },
          },
          {
            content: {
              title: "业务开拓：业务员躺着<br/>找客户的秘密武器",
              info: [
                {
                  title: "全球客户一键搜索",
                  desc: "覆盖全球市场，整合社交媒体与搜索引擎等多渠道数据，精准挖掘联系人邮箱，一键高效获客。",
                },
                {
                  title: "市场调研分析",
                  desc: "AI融合最新行业资讯，深度洞察市场情况，业务拓展不再迷失方向。",
                },
                {
                  title: "目标客户高效管理",
                  desc: "实时收录目标客户，轻松查看开发情况，分阶段精准营销。",
                },
                {
                  title: "客户深度洞察",
                  desc: "AI帮你全方位深度分析潜在客户的现状及开拓策略，让客户开发有的放矢。",
                },
                {
                  title: "千邮千面精准触达",
                  desc: "AI针对每个客户个性化生成邮件内容，EDM营销不再是千篇一律的广告传单。",
                },
                {
                  title: "图文海报智能生成",
                  desc: "通过描述即可一键生成营销图文素材，让多样化的营销形式不再依赖专业设计人员。",
                },
              ],
            },
          },
          {
            content: {
              title: "售前顾问支持工具：轻松打造<br/>专业全能的业务顾问",
              info: [
                {
                  title: "痛点挖掘及改善指南—现场运营痛点挖掘平台",
                  desc: "基于“场景地图”+“痛点菜单”选择的方式，轻松高效地帮助用户匹配最佳的数智化实践方案，快速获取大量有效项目机会。",
                },
                {
                  title: "AI精益改善顾问—现场运营模拟及分析平台",
                  desc: "用户通过导入人员、车辆、器具等资源数据，构建运营仿真场景，分析优化点，获取改善方案和预估效果，快速推动精益改善。",
                },
                {
                  title: "AI技术方案专家—AI方案在线生成平台",
                  desc: "通过AI大模型，帮助用户轻松解锁行业场景，精准捕捉痛点，实时生成专业解决方案，提升效率，降低营销成本。",
                },
                {
                  title: "系统演示及方案验证工具—Demo及培训演示平台",
                  desc: "用户通过远程实景操控体验IoT产品优化现场管理和工作流程，直观了解产品特性，实时验证方案效果，显著降低验证成本。",
                },
              ],
            },
          },
        ],
      },
      values: {
        title: "核心价值",
        list: [
          {
            title: "快速获取客户",
            desc: "全球客户信息数据挖掘，找到精准岗位人群",
          },
          {
            title: "销售难题指导",
            desc: "不同销售阶段的难题，个性化指导针对客户的处理回复",
          },
          {
            title: "全面售前顾问支持",
            desc: "从客户痛点挖掘到客户情况模拟分析，到解决方案生成，再到Demo演示及培训全流程的售前顾问支持工具",
          },
          {
            title: "高效促成交易",
            desc: "让销售团队单位时间内开拓3~5倍甚至更多的客户机会，提高业务成交概率",
          },
          // {
          //   title: "行业痛点AI诊断，<br/>方案秒级生成",
          //   desc: "基于大模型分析客户业务场景，自动输出定制化数智解决方案，缩短60%方案设计周期。",
          // },
          // {
          //   title: "在线模拟验证，<br/>试错成本降低90%",
          //   desc: "IoT远程操控+3D实景模拟，预演设备部署与流程优化效果，规避真实场景试错风险。",
          // },
        ],
      },
    },
    // AI建站
    AIbuilding: {
      contactTxt: "准备好革新您的网站体验了吗？",
      banner: {
        content: "AI智能建站，<br/>90秒生成企业级网站",
        desc: "加载速度提升50%，100+行业专属模板，一站式省心托管！",
      },
      advantage: {
        list: [
          {
            title: `90秒极速建站<br/>效率提升<span class="text-primary">300%</span>`,
            desc: "传统建站需4-6周，AI建站仅需90秒",
          },
          {
            title: `多语言自动适配<br/>本地化成本降低<span class="text-primary">70%</span>`,
            desc: "支持多种语言自动翻译语义准确率98%",
          },
          {
            title: `一站式省心托管<br/>业务营销效率提升<span class="text-primary">80%</span>`,
            desc: "一站式的网站托管服务，效率提升80%",
          },
          {
            title: `无代码设计<br/>迭代效率提升<span class="text-primary">10倍</span>`,
            desc: "拖拽式+AI布局建议，设计时间减少90%",
          },
        ],
      },
      platform: {
        title: "老板自己就能搞定的专业官网",
        list: [
          {
            title: "智能建站引擎<br/>AI驱动的网站架构设计",
            desc: `基于2000万+行业数据点自动生成优化的页面结构<br/>一站式省心托管<br/>内容规划速度提升<span class="text-primary nums">80%</span>，业务营销效率提升<span class="text-primary nums">80%</span>`,
          },
          {
            title: "可视化智能编辑<br/>无代码设计工作室",
            desc: `拖拽组件，AI提供布局建议<br/>实时品牌规范检查<br/>设计迭代速度提升<span class="text-primary  nums">10倍</span>，<span class="text-primary  nums">100%</span>品牌一致性`,
          },
          {
            title: "实时多语言适配<br/>智能全球化本地化",
            desc: `自动翻译内容至12种语言，并进行上下文优化<br/>同步生成地区合规页面<br/>本地化成本降低<span class="text-primary  nums">70%</span>，加速全球业务扩展`,
          },
        ],
      },
      vs: {
        title: "传统建站 vs 我们的AI建站",
        column: {
          items: "",
          others: "传统建站",
          ours: "我们的AI建站",
        },
        list: [
          {
            items: "开发周期",
            others: "4-6周",
            ours: "<90 秒",
          },
          {
            items: "多语言支持",
            others: "手动翻译",
            ours: "12种语言自动生成",
          },
          {
            items: "移动端适配",
            others: "额外成本",
            ours: "包含并自动优化",
          },
          {
            items: "持续维护成本",
            others: "每月$500+",
            ours: "免费自动更新",
          },
        ],
      },
    },
    // 业务开拓工具
    business: {
      banner: {
        content: "智能商机挖掘与全周期客户开发",
        desc: `我们专注于通过全球商机智能挖掘、全周期客户开发和AI智能营销，帮助企业精准捕捉市场机会，<br />提升客户开发效率，实现持续增长。`,
      },
      video: {
        tabsList: [
          {
            label: "客户搜索",
          },
          {
            label: "客户管理",
          },
          {
            label: "客户洞察",
          },
          {
            label: "市场分析",
          },
          {
            label: "个性化EDM",
          },
          {
            label: "AI图文海报",
          },
        ],
      },
      platform: {
        list: [
          {
            content: {
              title: "客户搜索：<br/>全球商机智能挖掘",
              info: [
                {
                  title: "360°客户画像构建",
                  subTitle: "3分钟定位目标客户关键联系人",
                  desc: `<p>支持关键词/公司名称/行业标签等多维度搜索</p><p>整合LinkedIn、海关数据、行业报告等20+数据源</p>`,
                },
                {
                  title: "采供链关系图谱",
                  subTitle: "提前发现潜在合作机会，商机转化率提升300%",
                  desc: `<p>可视化展示客户上下游业务关系网</p><p>实时追踪客户采购及竞品合作动态</p>`,
                },
              ],
            },
          },
          {
            content: {
              title: "客户开发：<br/>全周期客户开发引擎",
              info: [
                {
                  title: "开发进展追踪",
                  subTitle: "销售跟进响应速度提升80%",
                  desc: `<p>邮件阅读次数、公司实时信息AI分析</p><p>根据客户互动触发EDM/短信/社媒触达</p>`,
                },
                {
                  title: "个性化EDM机器人",
                  subTitle: "打开率提升65%，回复率提升40%",
                  desc: `<p>多主题模板库，满足不同开发需求</p><p>结合企业洞察数据，AI智能动态改写邮件</p>`,
                },
              ],
            },
          },
          {
            content: {
              title: "客户洞察：<br/>AI赋能客户深度洞察",
              info: [
                {
                  title: "智能画像解码需求痛点",
                  subTitle: "3分钟快速找准合作机会",
                  desc: `<p>用AI分析客户现状和行业痛点，自动匹配你的优势资源，<br/>直接锁定最可能成交的合作场景。</p>`,
                },
                {
                  title: "策略沙盘预演商机转化",
                  subTitle: "给方法，能落地",
                  desc: `<p>提供与跟客户沟通痛点完整执行建议，帮你少走弯路快速拿单。</p>`,
                },
              ],
            },
          },
          {
            content: {
              title: "市场调研：<br/>智策市场分析通",
              info: [
                {
                  title: "多维数据全景洞察",
                  subTitle: "提升分析效率80%，助力决策周期缩短50%",
                  desc: `<p>智能整合市场规模、竞品份额及用户画像，<br/>AI算法实时预测市场饱和度与增长率，精准定位未开发需求。</p>`,
                },
                {
                  title: "智能策略与风控引擎",
                  subTitle: "风险预警准确率达90%，市场进入成功率提升70%",
                  desc: `<p>基于动态数据生成本土化营销策略、 <br/>定价模型及风险预警，确保决策高效可靠。</p>`,
                },
              ],
            },
          },
          {
            content: {
              title: "图文海报：<br/>AI智能营销工场",
              info: [
                {
                  title: "文生图海报引擎",
                  subTitle: "设计成本降低90%，素材产出效率提升10倍",
                  desc: `<p>输入描述关键词自动生成营销素材</p><p>智能适配社媒平台尺寸规范</p>`,
                },
                {
                  title: "品牌视觉管理系统",
                  subTitle: "确保全球营销物料品牌一致性",
                  desc: `<p>自动管理生成物料，便于二次营销</p><p>AI生成内容自动合规性检查</p>`,
                },
              ],
            },
          },
        ],
      },
    },
    // 售前顾问支持工具
    preSales: {
      banner: {
        content: "运营痛点挖掘<br/>改善评估及实践AI大模型",
        desc: "为合作伙伴提供全方位的商业增长助力",
      },
      data: {
        list: [
          {
            label: "商机增加",
          },
          {
            label: "销售成本节约",
          },
          {
            label: "销售效率提升",
          },
          {
            label: "用户立项周期缩短",
          },
        ],
      },
      model: {
        title: '运营痛点挖掘、改善评估及实践AI大模型',
        list: [
          {
            title: `现场运营<br/>痛点挖掘平台`,
            desc: `基于“场景地图”+“痛点菜单”选择的方式，轻松高效地帮助用户匹配最佳的数智化实践方案，快速获取大量有效项目机会。`,
          },
          {
            title: `AI大模型方案<br/>自动生成平台`,
            desc: `通过AI大模型辅助用户轻松解锁各行业典型业务场景，精准捕捉场景痛点，实时生成针对性的专业解决方案，有效提升工作效率，降低营销成本。`,
          },
          {
            title: `现场运营痛点<br/>模拟及优化平台`,
            desc: `用户通过导入人员、车辆、器具等资源行为数据，构建运营仿真场景，深入诊断分析现场运营优化点，获取相应的改善方案与预估的改善效果，加速精益改善过程。`,
          },
          {
            title: `现场运营<br/>改善实践平台`,
            desc: `用户通过远程实景操控的方式，亲身体验IoT产品对现场管理和工作流程的优化，直观了解产品特性，实时验证方案效果，大大缩短方案验证成本。`,
          },
        ],
      },
      platform: {
        list: [
          {
            tabTitle: `现场运营痛点挖掘平台`,
            title: `现场运营痛点挖掘平台`,
            desc: `基于"场景地图"+"痛点菜单"选择的方式，轻松高效地帮助用户匹配最佳的数智化实践方案，快速获取大量有效项目机会。`,
            videoList: [
              {
                label: `行业选择`,
                desc: `丰富的实景实践场地，满足多样化的Demo实践需求`,
              },
              {
                label: `场景痛点筛选`,
                desc: `场景及痛点直观展示，精准挖掘需求机会`,
              },
              {
                label: `方案查看`,
                desc: `多类型IoT应用方案快速匹配`,
              },
              {
                label: `预算及ROI预估`,
                desc: `投资预算及ROI快速预估`,
              },
            ],
          },
          {
            tabTitle: `AI大模型方案自动生成平台`,
            title: `AI大模型方案自动生成平台`,
            desc: `通过AI大模型辅助用户轻松解锁各行业典型业务场景，精准捕捉场景痛点，实时生成针对性的专业解决方案，有效提升工作效率，降低营销成本。`,
            videoList: [
              {
                label: "行业选择",
                desc: `收集了丰富的行业场景，减少行业顾问人才投入`,
              },
              {
                label: "场景痛点筛选",
                desc: `场景及痛点直观展示，精准挖掘需求机会`,
              },
              {
                label: `AI方案自动生成`,
                desc: `AI一键自动生成方案及详细内容，效率成倍提升`,
              },
              {
                label: `方案在线快速编辑`,
                desc: `方案在线编辑功能，高效完成方案输出`,
              },
              {
                label: `丰富素材库选择`,
                desc: `提供丰富的素材库，满足个性化快速修改的需求`,
              },
              {
                label: `自定义方案模板及素材`,
                desc: `支持个性化模板及素材上传，满足用户多样化需求`,
              },
            ],
          },
          {
            tabTitle: `现场运营痛点模拟及分析平台`,
            title: `现场运营痛点模拟及分析平台`,
            desc: `用户可自主构建可视化的运营仿真现场，深入诊断分析各类运营资源的可改善点，获取相应的改善方案与预估的改善效果，加速精益改善过程。`,
            videoList: [
              {
                label: `基础数据录入`,
                desc: `支持自主导入现有资源的行为数据，快速构建仿真分析模型。`,
              },
              {
                label: `可视化仿真模拟`,
                desc: `生成可视化地图模拟仿真运营动态，全面展示各类资源的运营指标。`,
              },
              {
                label: `AI智能分析`,
                desc: `AI智能诊断分析可优化点，推荐对应方案与预估效果`,
              },
              {
                label: `优化方案对比`,
                desc: `自主组合多种改善方案集，直观对比改善效果，快速决策改善方向。`,
              },
            ],
          },
          {
            tabTitle: `现场运营改善实践平台`,
            title: `现场运营改善实践平台`,
            desc: `用户通过远程实景操控的方式，亲身体验IoT产品对现场管理和工作流程的优化，直观了解产品特性，实时验证方案效果，大大缩短方案验证周期，降低验证成本。`,
            videoList: [
              {
                label: `场景选择`,
                desc: `丰富的实景实践场地，满足多样化的Demo实践需求`,
              },
              {
                label: `资源赋能情况查看`,
                desc: `直观展示多种IoT产品对现场运营资源对象的赋能`,
              },
              {
                label: `参数自主配置`,
                desc: `支持自主配置场景中的多种参数，提供个性化的深度体验`,
              },
              {
                label: `实体对象实时操控`,
                desc: `沉浸式远程操控方式，多方位视角自由观察`,
              },
              {
                label: `业务改善效果体验`,
                desc: `随时随地快速验证及演示方案实际应用效果，低成本加速方案理解`,
              },
            ],
          },
        ],
      },
      core: {
        title: `核心功能价值`,
        list: [
          {
            label: `行业方案赋能`,
            desc: `丰富的行业全景图及核心场景应用方案，提供大量方案灵感及行业经验总结`,
          },
          {
            label: `多IoT融合，高ROI`,
            desc: `每个场景从单IoT到多IoT融合应用，多要素数字化赋能，提升效益，ROI更高`,
          },
          {
            label: `商机开拓增长`,
            desc: `帮助伙伴进行老客户新痛点挖掘，以及新客户新场景快速切入，获取大量有效需求`,
          },
          {
            label: `加速项目推进`,
            desc: `加速适配数智化场景、痛点及ROI，快速Demo验证，加速信息沟通效率`,
          },
          {
            label: `降低营销成本`,
            desc: `单次拜访可高效完成多场景多痛点“点菜式”交流；远程Demo验证，减少差旅成本`,
          },
          {
            label: `减少专业人才依赖`,
            desc: `AI方案自动生成，减少专业顾问人才依赖，<br/>降低人才成本投入`,
          },
        ],
      },
    },
    // 关于我们
    about: {
      contactTxt: '联系我们，开启您的全球化营销数智加速之路！',
      banner: {
        content: `一站式提供市场分析、全球获客、客户沟通、策略指导、<br />售前顾问、技术支持等全流程AI销售及售前顾问工具。`,
        tools: [
          {text: 'analytics'},
          {text: 'leads'},
          {text: 'contact'},
          {text: 'guidance'},
          {text: 'consulting'},
          {text: 'support'},
        ],
        desc: "专为“企业服务及非标品业务”打造的一站式全球业务开拓平台！",
      },
      data: {
        list: [
          {
            label: "销售成本降低",
          },
          {
            label: "客户开拓效率提升",
          },
          {
            label: "客户成功率提升",
          },
          {
            label: "销售周期缩短",
          },
        ],
      },
      introduction: {
        title: "关于Xpirory",
        content: `
          <p>
            Xpirory总部位于新加坡，是一家专注为企业服务及非标品业务厂商提供一站式的全球销售及售前顾问工具的创新型科技公司。我们以AI驱动为核心技术优势，致力于通过智能化工具与数据洞察，帮助企业突破地域限制，在全球市场开启高效精准的业务开拓新征程。
          </p>
          <p>
            我们拥有企业级的AI业务开拓平台，深度整合市场分析、全球获客、客户沟通、策略指导、售前顾问、技术支持等全流程服务，形成从市场洞察到客户转化的完整闭环。通过AI算法精准捕捉全球行业趋势与客群需求，结合多元化的AI自动化业务开拓工具，助力企业高效 触达目标客户、优化销售流程、提升线索转化率，让全球业务开拓变得轻松便捷。
          </p>
          <p><span style="font-weight: 700;border-bottom: 0.25rem solid #1a65ff;">我们的愿景</span>：成为全球企业服务及非标品业务业务开拓的核心驱动力！</p>
          <p><span style="font-weight: 700;border-bottom: 0.25rem solid #1a65ff;">我们的使命</span>：通过人工智能技术赋能企业实现智能化的业务开拓模式，加速拓展全球市场！</p>
          <p>
            Xpirory将持续投入Al技术研发力量，以全球化视野深耕行业场景，服务全球企业服务及非标品业务商。同时，我们也期待与更多合作伙伴携手，共同探索AI与业务开拓的深度融合，推动业务开拓模式的智能化转型，助力全球企业服务及非标品业务商在数字化浪潮中抢占先机，共创智能未来。
          </p>
          <p style="font-size: 1.375rem;font-weight: 700;">Xpirory，以科技链接全球市场，用AI重塑开拓范式！</p>
        `,
      },
    },
    // 定价
    pricing: {
      contactTxt: '联系我们，开启您的全球化业务开拓数智加速之旅！',
      banner: {
        content: `一站式业务开拓平台定价`,
        desc: "通过AI驱动的一站式业务开拓平台，助力企业快速开拓国际市场并实现高效转化",
      },
      vs: {
        column: {
          items: "",
          freeVision: "免费版",
          freeVisionInfo: `简要介绍...`,
          enterpriseVision: "企业版",
          enterpriseVisionInfo: `简要介绍...`,
          proVision: "高级应用版本",
          proVisionInfo: `简要介绍...`,
        },
        list: [
          {
            items: "服务场景",
            freeVision: "",
            freeVisionInfo: `简要介绍...`,
            enterpriseVision: "",
            enterpriseVisionInfo: `简要介绍...`,
            proVision: "",
            proVisionInfo: `简要介绍...`,
          },
          {
            items: "支持功能",
            freeVision: "",
            enterpriseVision: "",
            proVision: "",
            children: [
              {
                items: "功能点1",
              },
              {
                items: "功能点2",
              },
              {
                items: "功能点3",
              },
              {
                items: "功能点4",
              },
              {
                items: "功能点5",
              },
              {
                items: "功能点6",
              },
              {
                items: "功能点7",
              },
              {
                items: "功能点8",
              },
            ],
          },
          {
            items: "标准价格",
            freeVision: `XX<span class="fs_16 ml-1">元/小时</span>`,
            freeVisionButton: "点击进入",
            enterpriseVision: `XX<span class="fs_16 ml-1">元/小时</span>`,
            enterpriseVisionButton: "立即试用",
            proVision: `具体情况联系报价`,
            proVisionButton: "联系我们",
          },
        ],
      },
    },
    // 联系我们
    contact: {
      banner: {
        title: '联系我们',
        desc: '对我们的产品、公司或其他方面有疑问吗？',
      },
      main: {
        title: '想了解更多？',
        desc: '请填写以下表格，我们会尽快回复您！',
        msg1: '持续获取更多最新资讯，<br/>欢迎在社交媒体上关注我们！',
        msg2: '提出问题、反馈或只是打个招呼，<br/>我们期待各种形式的互动！',
        formItem1: '名',
        formItem2: '姓',
        formItem3: '电话',
        formItem4: '邮箱',
        formItem5: '公司名称',
        formItem6: '国家/地区',
        formItem7: '资讯信息',
        submitBtn: '立即提交',
        successMsg: '提交成功!',
        failedMsg: '系统异常!',
      }
    },
    // 售前顾问支持工具New
    supportTools: {
      banner: {
        title: 'AI售前顾问支持助手：',
        content: `4大售前顾问能力支撑平台，有效线索产出<br>增加300%~500%，项目推进周期缩短30~40%。`,
        desc: "业务痛点深度挖掘，运营问题直观模拟，解决方案快速生成，应用效果高效演示！",
        mobileDesc: "业务痛点深度挖掘，运营问题直观模拟，解决方案快速生成，应用效果高效演示！",
        btnText: '申请体验',
      },
      tryBtn: '点击试用',
      platform: {
        btnGroup: {
          btn1: '痛点挖掘专家',
          btn2: '运营模拟分析平台',
          btn3: '解决方案生成平台',
          btn4: 'Demo及培训平台',
        },
        list: [
          {
            title: `业务痛点挖掘及改善指南，<br>高值痛点挖掘效率提升300%-500%`,
            videoList: [
              {
                label: `多行业场景配置`,
                desc: `打破跨行业的经验壁垒，赋能售前顾问多行业的业务经验， 减少专业顾问投入`,
              },
              {
                label: `高ROI痛点收录`,
                desc: `业务痛点结构化输出， 让每个一线业务人员具备专家级的痛点挖掘能力`,
              },
              {
                label: `最佳实践方案匹配`,
                desc: `绑定每个痛点的最佳实践方案，高效锁定客户需求方向`,
              },
              {
                label: `AI智能搜索助理`,
                desc: `随时响应的专属AI专家顾问,海量业务知识高效总结提炼`,
              },
            ],
          },
          {
            title: `AI精益改善顾问，运营趋势模拟，<br>改善价值评估效率成倍提升`,
            videoList: [
              {
                label: "便捷构建资源分析模型",
                desc: `支持自主构建资源行为数据，建立多维度的联动运营分析基础`,
              },
              {
                label: "可视化运营模拟分析",
                desc: `资源可视化运营动态模拟，全面展示各类资源的运营指标`,
              },
              {
                label: `AI智能分析及方案推荐`,
                desc: `AI全面精准挖掘潜在痛点，快速预估可量化的改善效果，降低投资方向误判风险`,
              },
              {
                label: `优化方案组合量化对比`,
                desc: `直观对比多种方案的量化指标变化，提供有效的决策依据，极大缩短立项周期`,
              },
            ],
          },
          {
            title: `多语言AI技术方案专家，解决方案<br>轻松生成，方案制作效率提升300%-500%`,
            videoList: [
              {
                label: `专业内容生成`,
                desc: `可指定多个参考文档，让AI生成内容更专业`,
              },
              {
                label: `生成语言选择`,
                desc: `多语言选择，轻松应对全球客户服务`,
              },
              {
                label: `可控方案模板`,
                desc: `轻松构建可控的方案生成模板，更匹配企业方案应用需求`,
              },
              {
                label: `快速在线编辑`,
                desc: `多种在线编辑工具和素材，高效完成方案调整`,
              },
              {
                label: `团队方案共享`,
                desc: `成熟标准方案一键收录，团队成员快速共享`,
              },
              {
                label: `场景地图关联`,
                desc: `自定义行业地图，痛点分类归纳，方案适用场景一目了然`,
              },
            ],
          },
          {
            title: `Demo远程实景演示，打破场地<br>和设备限制，演示成本降低90%`,
            videoList: [
              {
                label: `实践场地自由选择`,
                desc: `丰富的实景场景选择，无需部署安装，低成本满足多样化的Demo 演示需求`,
              },
              {
                label: `运营资源赋能方式展示`,
                desc: `直观展示资源对象赋能方式，抽象方案直观呈现`,
              },
              {
                label: `操控参数自主配置`,
                desc: `支持自主配置现场设备的多种参数，快速建立用户对设备的全面认知`,
              },
              {
                label: `实体对象实景操作`,
                desc: `多摄像头联动，低成本实现沉浸式 Demo操控体验`,
              },
              {
                label: `开放场景自由对接`,
                desc: `支持接入自有系统，实现软硬件一体化联动演示`,
              },
            ],
          },
        ],
      },
      valuations: {
        msg1: '给俄罗斯客户设计跨境物流方案时，AI 自动分析莫斯科清关政策，生成的多币种报价单直接签单！客户开拓模块用俄语推送‘中欧班列时效对比’，本月新签10+客户！',
        msg2: '以前和客户聊需求总在盲人摸象，现在用场景地图筛选痛点问题，客户直接对号入座，当场就说"这就是我们车间的问题！"，有效线索挖掘效率直接翻倍。',
        msg3: '把 MES 系统的接入Demo平台后，直接将软件的过点信息采集功能和采集硬件连通，低成本地让客户直观地看到了软件和硬件之间的配合效果，客户感慨到“比起原来我们自己手动扫描高效了很多啊。”一下子我们的项目订单又增加了近百万的现场采集设备的采购',
        msg4: '以前遇到和客户的销售难题，只能自己想办法，没想到在Xpirory上面的困境破局大师居然有详细的销售难题指导，并且总结归纳和很多种我们经常遇到的情况。这个对我们业务推进真的太有帮助了！',
        msg5: '车间主任一开始抵触新工具，现在自己都会用手机查看模拟结果，他说："比玩抖音还简单，我都教会三个班组长了"。',
        msg6: '给海外工厂做方案时，时差问题让沟通很头疼，现在直接共享实时模拟画面，德国工程师边看边改参数，项目周期缩短了 40%。',
        msg7: '给客户高层展示仓储优化方案时，用远程实景Demo进行现场演示，对方物流总监当场理解了方案的落地应用效果，同意立项打造自己的智能仓库，在以前可能得来来回回折腾好趟呢！',
        msg8: '给汽车厂客户讲方案时，客户临时要求调整方案的方向，我们通过解决方案生成平台，找到对应的参考资料，一下子就生成了针对该客户的新方案，一次沟通就锁定了客户的想法，不用再花几天时间来回修改方案，来回出差沟通了。',
        msg9: '上周给客户做了一下现场的运营模拟分析，屏幕上直观看到叉车空驶时间特别多，客户工程师都凑过来看："原来车辆利用率这么糟糕啊！"，当场就决定针对叉车做个专项优化。',
        msg10: '以前只敢接家电客户，现在用行业全景图连航空航天的转包业务都敢碰，销售经理说："AI 比老顾问知道的行业还多"。',
        msg11: '刚入职的销售用方案生成平台很快就上手了我们的业务，即使之前没有什么医疗行业的经验，他也完全可以对照客户场景，很快生成对应的介绍方案，他说："AI什么都懂，一个人见客户也没有太大的难度"。',
        msg12: '给客户讲解AGV协同管理的逻辑客户总是不能理解，我们使用Demo演示平台，通过远程实景画面直接操作给客户看，一下子他就懂了。直观的演示让客户对抽象的逻辑有了清晰的概念。关键是我们还不用真的搬几台AGV去现场演示给客户看。',
        msg13: '给电子厂做改善时，我们使用模拟分析平台进行评估，AI自动推荐了多种优化方案给我们，通过直观的数据对比，客户很快就确定了他想要先改善什么。',
        msg14: '关经理',
        msg15: '朱先生',
        msg16: '丁女士',
        msg17: '蒋先生',
        msg18: '李先生',
        msg19: '翟先生',
        msg20: '王先生',
        msg21: '光先生',
        msg22: '刘女士',
        msg23: '国际物流方案集成商',
        msg24: '某制造业集成商',
        msg25: '汽车行业',
        msg26: '某解决方案提供商',
        msg27: '工程公司',
        msg28: '轮胎行业',
        msg29: '某叉车改造解决方案商',
        msg30: '金属加工设备商',
        msg31: '系统开发商',
        msg32: '集成商',
        msg33: '工业物联网服务商',
      },
      values: {
        title: "核心价值",
        list: [
          {
            title: "深度挖掘客户痛点，<br>精准定位客户问题，<br>痛点准确率提升80%",
            mobileTitle: '深度挖掘客户痛点，<br>精准定位客户问题，<br>痛点准确率提升80%',
          },
          {
            title: "即时模拟运营趋势，<br>可视化传递价值认知，<br>客户认知率成倍提升",
            mobileTitle: '即时模拟运营趋势，<br>可视化传递价值认知，<br>客户认知率成倍提升',
          },
          {
            title: "快速生成解决方案，<br>高效响应客户需求，<br>客户满意度提升50%",
            mobileTitle: '快速生成解决方案，<br>高效响应客户需求，<br>客户满意度提升50%',
          },
          {
            title: "远程实景Demo演示，低<br>成本高效展示服务价值，<br>客户决策效率提升50%",
            mobileTitle: '远程实景Demo演示，低成本高效展示服务价值，客户决策效率提升50%',
          },
        ],
      },
    },
    // AI销售业务开拓助手
    developTools: {
      banner: {
        title: 'AI销售业务开拓助手：',
        content: `6大核心功能，让客户开拓效率提升300~500%，<br>企业销售成本降低40~50%。`,
        desc: "智能挖掘全球商机，精准触达目标客户，AI销售专家难题指导，助力企业业绩倍增!",
      },
      btnText: '市场分析',
      btnText2: '全球获客',
      btnText3: '客户洞察',
      btnText4: '图文海报制作',
      btnText5: '语音同传及策略沟通助手',
      btnText6: '智能邮件',
      btnText7: '困境策略大师',
      viewDetails: '查看详情',
      platform: {
        list: [
          {
            title: `精准分析目标市场，<br>踩坑风险减少80%`,
            videoList: [
              {
                label: `数据雷达`,
                desc: `整合行业近况、需求痛点、产业上下游、竞争及差异化、政策环境等多维度数据`,
              },
              {
                label: `市场导航`,
                desc: `在目标市场中分析进入路线、市场定位、运营策略等，帮助企业精准导航`,
              },
              {
                label: `风险评估`,
                desc: `结合政治、金融、法规等多方面信息评估市场风险和退出策略，未雨绸缪`,
              },
            ],
          },
          {
            title: `全球客户雷达，精准获取目标，<br>提效300%-500%`,
            videoList: [
              {
                label: "多维度搜寻客户",
                desc: `采购商、供应商、关键词等多维度搜索客户，获取客户信息，快速找到目标客户`,
              },
              {
                label: "采供链穿透",
                desc: `360度上下游分析，快速理清客户关系网`,
              },
              {
                label: `竞争品溯源`,
                desc: `顺藤摸瓜，找到竞品的客户`,
              },
            ],
          },
          {
            title: `客户洞察，精准掌握企业信息，<br>拓客成功率提升50%-80%`,
            videoList: [
              {
                label: `痛点扫描`,
                desc: `可通过分析客户的全方位可获取数据找到客户行业典型痛点，及供方与客户之间的可能合作机会`,
              },
              {
                label: `策略分析`,
                desc: `结合供方及客户的情况给出业务开拓的策略分析建议`,
              },
              {
                label: `风险评估`,
                desc: `结合客户市场情况及竞品信息给予竞争风险和合作风险评估`,
              },
            ],
          },
          {
            title: `营销资料高效制作，<br>成本降低80%`,
            videoList: [
              {
                label: `生图魔法`,
                desc: `多种行业及场景风格，快捷使用指导，高效生成专业图片`,
              },
              {
                label: `营销素材知识库`,
                desc: `构建丰富且随时可用的销售素材知识库供AI取用`,
              },
              {
                label: `海报达人`,
                desc: `无须专业编辑工具，即可快速结合知识库生成多语言营销海报，风格内容完全可控`,
              },
            ],
          },
          {
            title: `无障碍语音沟通，AI智能辅助<br>沟通效率大幅度提升`,
            videoList: [
              {
                label: `低延时语音同传翻译`,
                desc: `低延时同传翻译，直接说中文，对方即可听到翻译后的流利英文，没有中文原声干扰，跨境会议也能像和本地人交流一样简单`,
              },
              {
                label: `实时AI策略建议`,
                desc: `会议中自动分析对方话语，如质疑、施压、挑战等，实时推送应对策略，辅助业务人员轻松应对`,
              },
              {
                label: `智能术语解析`,
                desc: `自动捕捉行业术语或热度术语，实时提供术语解析，消除知识盲区，避免语义偏差，轻松保持与客户同频交流`,
              },
              {
                label: `一键对话总结`,
                desc: `会议结束后，一键总结会议要点及行动计划，省去人工整理，高效推动工作落地`,
              },
              {
                label: `隐身模式+小窗交互`,
                desc: `投屏后智能隐形，不出现在对方电脑屏幕，并且可以通过小窗模式进行最小化显示，不干扰正常投屏及沟通过程`,
              },
            ],
          },
          {
            title: `无障碍语言沟通，AI智能辅助<br>沟通效率大幅度提升`,
            videoList: [
              {
                label: `AI智能邮件话术生成`,
                desc: `结合销售阶段及业务背景，根据不同阶段的销售难题，自动生成个性化邮件话术及指导意见`,
              },
              {
                label: `多语种商务邮件翻译`,
                desc: `提供不仅在文字层面、 还包括对方文化中的商务交往习惯的多语言翻译`,
              },
              {
                label: `便捷邮件模板`,
                desc: `支持预编辑多种常用的邮件模板，便捷发送`,
              },
            ],
          },
          {
            title: `困境策略大师，<br>客户成功率提高50%-80%`,
            videoList: [
              {
                label: `销售难题库`,
                desc: `共享不同销售阶段的各类销售难题，快速找到参考`,
              },
              {
                label: `AI销售专家`,
                desc: `针对销售难题自动生成处理回复的方法和建议`,
              },
              {
                label: `个性化指导`,
                desc: `深度结合企业信息和客户信息，定制企业专属的指导意见`,
              },
            ],
          },
        ],
      },
      valuations: {
        msg1: '给俄罗斯客户设计跨境物流方案时，AI 自动分析莫斯科清关政策，生成的多币种报价单直接签单！客户开拓模块用俄语推送‘中欧班列时效对比’，本月新签10+客户！',
        msg2: '给迪拜智能交通项目投标时，AI 生成阿拉伯语动态流程图，把我们的 V2X 技术优势分步骤展示，评标专家说‘这是最清晰的方案’，中标后客户主动追加了 5G 基站订单',
        msg3: '给肯尼亚灌溉项目报价时，AI 提醒客户可能质疑设备耐腐蚀性，提前准备了盐雾测试报告 + 当地成功案例，谈判时直接堵住客户疑虑，项目利润率比预期高 8%！',
        msg4: '本来要放弃瑞典医疗设备市场，通过市场分析模块我们重新分析了瑞典市场情况，发现家庭护理设备需求有明显增长，我们立刻调整了推广的产品和方案，2个月内咨询量一下子翻了3倍！',
        msg5: '非常推荐这款便捷的图文海报制作工具。这款工具通过提供多种场景风格的模板，以及快捷的使用指导，大幅降低了营销资料制作的复杂性和成本，实现了高效生成专业图片的目标。',
        msg6: '业务员每次给客户写邮件费时又费力，而且总是没办法完全解决客户的顾虑。现在通过困境策略大师的功能，AI直接给出了保姆级的指导，每个业务员都可以轻松写出高质量的邮件，客户的成交周期缩短了至少30%。',
        msg7: '每次做客户背调都耗费好多时间，网上各种资料信息参差不齐，而且有些语种还要找翻译工具慢慢翻译过来看，实在是难受！现在只要选好目标语言，AI几分钟就可以在网上看完客户相关的资讯，给出开拓建议，和具体的业务结合点，这一下子就节省了4、5个专职人员的时间成本。',
        msg8: '给客户高层展示仓储优化方案时，用远程实景Demo进行现场演示，对方物流总监当场理解了方案的落地应用效果，同意立项打造自己的智能仓库，在以前可能得来来回回折腾好趟呢！',
        msg9: '过去在邮件中回复客户关于产品、价格、交期等各类质疑时，常常感到棘手。如今，有了 AI 销售专家的助力，针对销售难题提供专业指导并自动生成邮件内容，不仅让我们与客户的沟通变得更加顺畅高效，项目推进也明显轻松了许多。',
        msg10: 'AI 分析全球机械展会数据，生成的俄语版加工效率对比报告成了最佳谈资！市场获客模块自动匹配俄罗斯基建项目，莫斯科展期间新增客户线索 120+',
        msg11: '真的只有用上这个业务开拓工具，才知道原来营销可以这么简单，真的在营销方面节省了我们团队大量时间，我们以后还会一直用下去！',
        msg12: '给某个汽车客户做车联网方案时，通过客户洞察我们了解到他们的专利布局在某项技术上是空白，这刚刚好可以直接匹配我们的一款定制模块。于是我们立刻联系到客户，客户说‘你们补全了我们的技术拼图’。通过不断的努力，我们最终顺利拿下了项目！',
        msg13: '以前遇到和客户的销售难题，只能自己想办法，没想到在Xpirory上面的困境破局大师居然有详细的销售难题指导，并且总结归纳和很多种我们经常遇到的情况。这个对我们业务推进真的太有帮助了！',
        msg14: '周先生',
        msg15: '王先生',
        msg16: '周女士',
        msg17: '石女士',
        msg18: '蒋先生',
        msg19: '冯先生',
        msg20: '希女士',
        msg21: '李先生',
        msg22: '赵先生',
        msg23: '孙先生',
        msg24: '陈女士',
        msg25: '医疗设备提供商',
        msg26: '软件集成商',
        msg27: '国际物流方案集成商',
        msg28: '医疗IT提供商',
        msg29: '某解决方案提供商',
        msg30: '制造业',
        msg31: '软件外包商',
        msg32: '金属加工设备商',
        msg33: '系统开发集成商',
        msg34: '系统开发商',
        msg35: '某集成商',
        msg36: '工业物联网服务商',
      },
      values: {
        title: "核心价值",
        list: [
          {
            title: "精准分析目标市场，踩坑<br>风险减少80%",
          },
          {
            title: "全球客户雷达，精准获取<br>目标，效率提升300%-500%",
          },
          {
            title: "客户洞察，精准掌握企业信息<br>拓客成功率提升50%-80%",
          },
          {
            title: "困境策略大师，<br>客户成功率提高50%-80%",
          },
          {
            title: "营销素材高效制作，<br>成本降低80%",
          },
        ],
      },
    },
    // 解决方案生成平台
    solution: {
      banner: {
        title: '解决方案生成平台',
        content: `企业知识AI自学习+模板及内容<span style="color: #1A64FE">可控</span>，<br>3分钟完成专业个性化方案，<br>让售前<span style="color: #1A64FE">轻松应对全球客户需求</span>`,
      },
      title1: 'Xpirory 解决方案生成平台',
      desc1: '深度理解企业知识库，支持自定义方案模板，AI 自动生成多语言专业方案，可一键收录至知识地图实现知识共享。',
      title2: '多语言AI技术方案专家，解决方案<br>轻松生成，方案制作效率提升300%-500%',
      platform: {
        list: [
          {
            title: `专业内容生成`,
            desc: '可指定多个参考文档，让AI生成内容更专业',
          },
          {
            title: `兼容 Office PPT 编辑`,
            desc: '支持常规文档上传，操作与Office PPT一致，且辅助快速生成内容',
          },
          {
            title: `生成语言选择`,
            desc: '多语言选择，轻松应对全球客户服务',
          },
          {
            title: `可控方案模板`,
            desc: '轻松构建可控的方案生成模板，更匹配企业方案应用需求',
          },
          {
            title: `快速在线编辑`,
            desc: '多种在线编辑工具和素材，高效完成方案调整',
          },
          {
            title: `团队方案共享及快速微调`,
            desc: '成熟标准方案一键收录、团队快速共享，且支持通过提示词快速整体微调',
          },
          {
            title: `场景地图关联`,
            desc: '自定义行业地图，痛点分类归纳，方案适用场景一目了然',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '“懂业务” 的智能生成',
          desc: '深度理解企业知识库，可生成的企业可用的专业解决方案内容，而非普通科普介绍材料',
        },
        {
          title: '可控模板及内容生成',
          desc: '支持企业自定义专属模板，生成内容严格关联企业知识库，避免通用化表述，确保方案专业且贴合业务',
        },
        {
          title: '方案复用及快速微调',
          desc: '历史方案按场景分类存档，可一键调用并快速调整适配新客户的微调点，多语言版本同步生成，大幅减少重复劳动',
        },
      ],
      scene: [
        {
          title: '客户方案快速定制',
          desc: '面向各类客户的想法，能快速定制个性化解决方案，不必担心线索不靠谱导致的无效售前资源投入',
        },
        {
          title: '海外多语言方案输出',
          desc: '快速为不同国家和地区的客户生成海外版方案，解决语言障碍，提高海外客户响应速度',
        },
        {
          title: '不同客户间方案快速复用',
          desc: '面对同行业不同客户时，可直接复用同类场景方案，仅需微调提示词，即可快速生成适配方案',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '方案制作耗时',
            },
            {
              label: '多语言输出',
            },
            {
              label: '知识复用率',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工模式',
            },
            {
              label: '定制方案 10+ 小时',
            },
            {
              label: '需专业翻译，耗时长',
            },
            {
              label: '难',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `定制方案 10-30 分钟<br/>（快速微调复用仅需1分钟）`,
            },
            {
              label: 'AI 自动生成，耗时短',
            },
            {
              label: '易',
            },
          ]
        },
      ],
      footerText: '立即申请免费试用',
    },
    // 痛点挖掘
    painPoints: {
      banner: {
        title: '痛点挖掘专家',
        content: `让每个销售都可拥有专家级痛点挖掘能力，<br><span style="color: #1A64FE">快速把握需求，让商机倍增</span>`,
      },
      title1: 'Xpirory 痛点挖掘专家',
      desc1: '通过构建企业专属知识体系，将专家经验转化为可复用的痛点挖掘工具，支持自然语言检索客户问题，助力一线人员完整捕捉高价值需求。',
      title2: '业务痛点挖掘及改善指南，高值痛点挖掘效率提升300%-500%',
      platform: {
        list: [
          {
            title: `多行业场景配置`,
            desc: '打破跨行业的经验壁垒，赋能售前顾问多行业的业务经验，减少专业顾问投入',
          },
          {
            title: `高ROI痛点收录`,
            desc: '业务痛点结构化输出，让每个一线业务人员具备专家级的痛点挖掘能力',
          },
          {
            title: `最佳实践方案匹配`,
            desc: '绑定每个痛点的最佳实践方案，高效锁定客户需求方向',
          },
          {
            title: `AI智能搜索助理`,
            desc: '随时响应的专属AI专家顾问，海量业务知识高效总结提炼',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '专家经验 “标准化”',
          desc: '将资深顾问的痛点挖掘逻辑转化为可复用工具，人人都能快速掌握 “如何挖掘客户痛点”，传统模式依赖个人经验传承',
        },
        {
          title: '分层引导挖掘',
          desc: '通过 “行业→场景→痛点” 三层架构，引导用户从模糊感觉拆解到具体问题',
        },
        {
          title: '自然语言精准检索',
          desc: '客户用口语化提问，AI 能秒级匹配对应解决方案，完美弥补每个人的知识储备差异',
        },
      ],
      scene: [
        {
          title: '老客户新机会挖掘',
          desc: '通过AI智能检索，对老客户的问题快速诊断，找到对应方案，快速孵化新的项目机会',
        },
        {
          title: '新客户新机会挖掘',
          desc: '分层引导，对新客户新机会进行全面挖掘，让项目开拓效率倍增',
        },
        {
          title: '给合作伙伴赋能',
          desc: '通过AI赋能，让合作伙伴也轻松具备原厂商一样的客户痛点挖掘及需求把握能力',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '痛点挖掘效率',
            },
            {
              label: '高价值痛点识别率',
            },
            {
              label: '方案匹配精准度',
            },
            {
              label: '业务培训周期',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工模式',
            },
            {
              label: '一次拜访沟通可能只能找到1个痛点',
            },
            {
              label: '低',
            },
            {
              label: '低',
            },
            {
              label: '长',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `一次拜访沟通可以找全所有痛点及需求`,
            },
            {
              label: '高',
            },
            {
              label: '高',
            },
            {
              label: '短',
            },
          ]
        },
      ],
    },
    // 市场分析
    marketAnalytics: {
      banner: {
        title: '市场分析',
        content: `AI 市场分析，5-10 分钟生成，<br><span style="color: #1A64FE">全语种信息来源+多维度分析</span><br>的高质量市场分析报告`,
      },
      title1: 'Xpirory 市场分析',
      desc1: '实时抓取目标市场所在国别的当地语言资讯及全球多国语种的相关信息资料，全方位智能分析目标市场的成熟度、饱和度、与您的业务匹配度、政策适配度、文化兼容性、竞品竞争力、财务风险等多个方面的信息。为出海企业或计划开拓新行业的企业提供市场选择的决策依据。',
      title2: '精准分析目标市场，踩坑风险减少80%，减少95%以上的时间投入',
      platform: {
        list: [
          {
            title: `数据雷达`,
            desc: '整合行业近况、需求痛点、产业上下游、竞争及差异化、政策环境等多维度数据',
          },
          {
            title: `市场导航`,
            desc: '在目标市场中分析进入路线、市场定位、运营策略等，帮助企业精准导航',
          },
          {
            title: `风险评估`,
            desc: '结合政治、金融、法规等多方面信息评估市场风险和退出策略，未雨绸缪',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '不止 “搬数据”，<br/>更给 “策略”',
          desc: '区别于传统工具单纯整合信息，AI市场分析工具可结合企业自身业务输出针对性的 “市场切入建议”，结论附溯源依据',
        },
        {
          title: '全语种实时抓取',
          desc: 'AI完整覆盖目标市场本地语言资讯（政策、新闻、竞品动态），避免因语言壁垒遗漏关键信息，随心所欲分析各个潜在市场',
        },
        {
          title: '分钟级响应',
          desc: '从数据抓取到报告生成全程自动化，压缩传统调研周期 90% 以上，助力企业快速迈出出海第一步',
        },
      ],
      scene: [
        {
          title: '新市场准入分析',
          desc: '企业计划开拓新市场，快速了解自身业务准入门槛与匹配度',
        },
        {
          title: '投资风险分析',
          desc: '评估目标市场财务风险、环境风险、政策风险等，提前规避投入风险',
        },
        {
          title: '市场竞争情况分析',
          desc: '分析竞品在目标市场的布局与弱点，制定针对性竞争策略',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '调研周期',
            },
            {
              label: '人力投入',
            },
            {
              label: '信息覆盖度',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工调研模式',
            },
            {
              label: '3-4周',
            },
            {
              label: '5人团队',
            },
            {
              label: '30%有效数据',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `几分钟`,
            },
            {
              label: '1人操作',
            },
            {
              label: '全语种线上信息资料挖掘',
            },
          ]
        },
      ],
      footerText: '立即生成你的首份市场报告',
    },
    // 全球获客
    globalCustomer: {
      banner: {
        title: '全球获客',
        content: `海量<span style="color: #1A64FE">高价值目标客户及决策人</span><br>快速查询，让业务开拓不再被动`,
      },
      title1: 'Xpirory 全球获客',
      desc1: '通过 “多维度组合搜索 + AI 实时分析 + 供应链穿透”，精准筛选目标客户并定位 VP 级决策人，附带企业概况、交易历史、联系方式等完整信息，降低获客成本与周期。',
      title2: '全球客户雷达，精准获取目标，提效300%-500%',
      platform: {
        list: [
          {
            title: `多维度搜寻客户`,
            desc: '采购商、供应商、关键词等多维度搜索客户，获取客户信息，快速找到目标客户',
          },
          {
            title: `采供链穿透`,
            desc: '360度上下游分析，快速理清客户关系网',
          },
          {
            title: `竞争品溯源`,
            desc: '顺藤摸瓜，找到竞品的客户',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '多源商业数据库',
          desc: '涵盖海关数据，社媒数据及多种商业数据，构成强大的To B业务商业数据库',
        },
        {
          title: 'AI智能检索匹配',
          desc: '通过AI能力智能匹配目标客户群体，帮助用户轻松实现主动出击',
        },
        {
          title: '智能洞察企业服务业务需求',
          desc: '配套AI客户洞察工具，深度探索客户潜在的企业服务业务及非标品业务需求',
        },
      ],
      scene: [
        {
          title: '潜在客户挖掘',
          desc: '自动化方案厂商开拓 “墨西哥” 市场，快速锁定与之服务匹配的目标企业',
        },
        {
          title: '竞品客户渗透',
          desc: '挖掘竞品的合作客户（如 “某竞品的北美代理商”），深度洞察其潜在需求及有效切入点',
        },
        {
          title: '合作伙伴开拓',
          desc: '通过查找与自身业务配套的供应商，共同开发最终用户，形成共赢合作',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '客户筛选周期',
            },
            {
              label: '决策人触达率',
            },
            {
              label: '获客成本',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工调研模式',
            },
            {
              label: '3 人团队耗时 2 周',
            },
            {
              label: '15%（多为基层对接人）',
            },
            {
              label: '展会 + 差旅 + 人工，成本高昂',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `输入条件后 10 分钟内锁定目标`,
            },
            {
              label: '>80%（直接触达 VP 级采购 / 技术决策人）',
            },
            {
              label: '工具成本仅为传统模式的 1/5',
            },
          ]
        },
      ],
    },
    // 客户洞察
    customerInsights: {
      banner: {
        title: '客户洞察',
        content: `相隔千里也能对海外客户进行深度<br>洞察，需求匹配<span style="color: #1A64FE">精准度提升 85%</span>`,
      },
      title1: 'Xpirory 客户洞察',
      desc1: '整合目标客户多语种全域数据（业务动态、采购历史、决策链等），分析自身业务与客户需求的匹配度，输出定制化开拓策略，让沟通更精准。',
      title2: '客户洞察，精准掌握企业信息，拓客成功率提升50%-80%',
      platform: {
        list: [
          {
            title: `痛点扫描`,
            desc: '可通过分析客户的全方位可获取数据，找到客户行业典型痛点，及供方与客户之间的可能合作机会',
          },
          {
            title: `开拓策略分析`,
            desc: '结合供方及客户的情况给出业务开拓的策略分析建议',
          },
          {
            title: `风险评估`,
            desc: '结合客户市场情况及竞品信息给予竞争风险和合作风险评估',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '需求深度匹配',
          desc: '不止生成客户画像，更分析 “企业产品能解决客户哪些痛点”，给出切入路径和业务契合点，以及潜在竞争对手信息，而传统工具仅提供基础信息',
        },
        {
          title: '跨文化偏好解码',
          desc: '结合当地商业文化习惯解析 “隐性需求”，避免文化差异导致的误判',
        },
        {
          title: '风险预判前置',
          desc: '自动筛选分析客户所在地的政策，洞察企业决策链变动等风险，预判风险，避免无效投入',
        },
      ],
      scene: [
        {
          title: '潜在客户需求解码',
          desc: '分析潜在客户的采购偏好，调整方案侧重点',
        },
        {
          title: '合作风险提前排查',
          desc: '预判合作风险，制定应对策略',
        },
        {
          title: '差异竞争优势探索',
          desc: '针对客户与竞品的合作痛点，设计差异化沟通话术',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '客户调研耗时',
            },
            {
              label: '需求匹配精准度',
            },
            {
              label: '沟通推进速度',
            },
            {
              label: '合作风险预判',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工调研模式',
            },
            {
              label: '2 人团队 1 周 / 1 家客户',
            },
            {
              label: '40%（依赖经验判断）',
            },
            {
              label: '平均 3 次沟通后明确需求',
            },
            {
              label: '无系统分析，依赖人工经验',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `1 小时 / 10 家客户`,
            },
            {
              label: '>85%（基于数据挖掘客户隐性需求）',
            },
            {
              label: '首次沟通即命中核心需求',
            },
            {
              label: '90% 高风险客户可提前预警',
            },
          ]
        },
      ],
    },
    // 图文海报制作
    smartPoster: {
      banner: {
        title: '图文海报制作',
        content: `10 分钟搞定 多语种海报<br>洞察，需求匹配<span style="color: #1A64FE">设计效率提升 80%+</span>`,
      },
      title1: 'Xpirory 图文海报制作',
      desc1: '结合企业业务知识生成多语言营销文案，支持上传品牌模板，AI 自动根据模板完成海报制作，大幅降低设计成本与周期。',
      title2: '营销资料高效制作，成本降低80%',
      platform: {
        list: [
          {
            title: `快捷生图、简单好用`,
            desc: '多种行业及场景风格，快捷使用指导，高效生成专业图片',
          },
          {
            title: `海报达人、快捷可控`,
            desc: '无须专业编辑工具，即可快速结合知识库生成多语言营销海报，风格内容完全可控',
          },
          {
            title: `构建海报知识库`,
            desc: '构建丰富且随时可用的销售素材知识库供AI取用',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '精准解析业务知识',
          desc: 'AI智能解析企业的各类业务资料，充分理解业务特点，快速生成精准可用的宣传文案',
        },
        {
          title: '品牌模板全可控',
          desc: '支持上传及编辑企业 VI 模板（LOGO、配色、字体），AI 生成时严格遵循规范，避免自由设计导致的品牌语言混乱',
        },
        {
          title: '版权无忧的专属素材',
          desc: 'AI 生成营销配图，替代图库素材，有效规避侵权风险，解决传统设计常因版权问题被迫更换素材',
        },
      ],
      scene: [
        {
          title: '多语言素材快速制作',
          desc: '为不同市场定制各类当地语言的营销海报，轻松覆盖多个市场',
        },
        {
          title: '社交媒体本地化营销',
          desc: '轻松制作社交媒体的本土化高频宣传资料，丰富社媒内容输出',
        },
        {
          title: '个性化营销物料输出',
          desc: '针对不同客户，快速生成个性化的营销资料，让营销更精细',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '单版制作耗时',
            },
            {
              label: '多语言适配',
            },
            {
              label: '版权风险',
            },
            {
              label: '品牌统一性',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工模式',
            },
            {
              label: '5-8 小时 <br/>（设计 + 翻译 + 改稿）',
            },
            {
              label: '需专业翻译，易出错',
            },
            {
              label: '高（依赖图库素材）',
            },
            {
              label: '低',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `10 分钟 <br/>（AI 自动生成 + 排版）`,
            },
            {
              label: 'AI智能学习翻译<br/>多语言精准转换',
            },
            {
              label: '0 风险（AI 生成专属图片）',
            },
            {
              label: '高',
            },
          ]
        },
      ],
    },
    // 语音同传及策略沟通助手
    speechTranslator: {
      banner: {
        title: '语音同传/策略沟通助手',
        content: `<span class="with-dot">低延时语音同传翻译</span><br/><span class="with-dot">AI实时策略建议及术语解析</span><br/><span style="color: #1A64FE">提升跨境/国内商务会议的沟通效率</span>`,
      },
      title1: 'Xpirory 语音同传/策略沟通助手',
      desc1: '专为企业商务会议设计，既能满足跨境沟通，又能满足本地沟通，聚焦 “业务 + 语言” 双需求：通过低延迟实时翻译、实时策略建议、专业术语解析、自动对话总结，解决传统会议中“业务能力和外语表达能力无法兼顾、行业术语或热点没有及时了解、沟通中难以对压力和挑战做出及时反应”等痛点，让跨境会议沟通更自然、更高效。',
      title2: '无障碍语音沟通，AI智能辅助沟通效率大幅度提升',
      platform: {
        list: [
          {
            title: `低延时语音同传翻译`,
            desc: '低延时同传翻译，支持边说边译，无需等待整句话说完即开始翻译；直接说中文，对方即可听到流利英文且无中文原声干扰，跨境会议也能像和本地人交流一样简单',
          },
          {
            title: `实时 AI 策略建议`,
            desc: '会议中自动分析对方话语，如质疑、施压、挑战等，实时推送应对策略，1秒出现应对话术，辅助业务人员轻松应对',
          },
          {
            title: `智能术语解析`,
            desc: '自动捕捉行业术语或热点术语，实时提供术语解析，消除知识盲区，避免语义偏差，轻松保持与客户同频交流',
          },
          {
            title: `一键对话总结`,
            desc: '会议结束后，一键总结会议要点及行动计划，省去人工整理，高效推动工作落地',
          },
          {
            title: `隐身模式 + 小窗交互`,
            desc: '会议共享屏幕时，软件化身为半透明浮动小窗口，且对于“对方”是“隐身”状态，既不遮挡己方的屏幕内容介绍，又不会让对方发现',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '从“延迟翻译”到“同步传译”',
          desc: '区别于传统翻译工具 “需等完整语句结束才翻译”，低延迟AI同传实现 “边说边译”，会议节奏更高效',
        },
        {
          title: '对方不安装任何软件，己方可复刻自己声音',
          desc: '对方无需安装任何软件，直接听到的就是己方经过翻译后的外语声音，还可复刻自己的声音音色，让对话体验更加自然',
        },
        {
          title: '不止“语言转换”，更懂“策略应对”',
          desc: '融合“翻译 + 策略建议”，实时分析场景对话，提供专业应对建议，进一步赋能业务人员',
        },
        {
          title: '术语智能捕捉解析，避免沟通语义偏差',
          desc: '自动捕捉行业 / 热度术语，实时提供解析，消除知识盲区，助力与客户同频交流',
        },
      ],
      scene: {
        type1: '国际沟通',
        type2: '国内沟通',
        typeData1: [
          {
            title: '国际客户沟通',
          },
          {
            title: '国际商务谈判',
          },
          {
            title: '海外沟通策略辅助',
          },
          {
            title: '海外团队同事沟通',
          },
          {
            title: '海外人员招募',
          },
          {
            title: '海外合作伙伴拓展',
          },
        ],
        typeData2: [
          {
            title: '本地客户沟通',
          },
          {
            title: '本地商务谈判',
          },
          {
            title: '本地供应商交流',
          },
          {
            title: '国内合作伙伴拓展',
          },
          {
            title: '本地沟通策略辅助',
          },
          {
            title: '本地招聘辅助',
          },
        ],
      },
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '翻译延迟',
            },
            {
              label: '对方感知干扰',
            },
            {
              label: '术语理解准确率',
            },
            {
              label: '对话中的挑战回应',
            },
            {
              label: '会议纪要耗时',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工翻译模式',
            },
            {
              label: '延迟大',
            },
            {
              label: '高（需要等待翻译人员完成翻译）',
            },
            {
              label: '60%（依赖人工翻译经验）',
            },
            {
              label: '反应慢 （依赖个人能力）',
            },
            {
              label: '2 小时 / 场（人工整理）',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `延迟小`,
            },
            {
              label: '无（隐身模式，对方无感知）',
            },
            {
              label: '85%+（AI 智能解析行业术语）',
            },
            {
              label: '反应快（实时分析出建议）',
            },
            {
              label: '30 秒 / 场（AI 自动生成）',
            },
          ]
        },
      ],
    },
    // 智能邮件
    smartEmail: {
      banner: {
        title: '智能邮件',
        content: `AI 搞定多国主流语种邮件沟通，<br/>智能话术指导 + 商务礼仪适配，<br/><span style="color: #1A64FE">邮件回复率提升60%+</span>`,
      },
      title1: 'Xpirory 智能邮件',
      desc1: '聚焦企业服务及非标品出海的邮件营销与商务沟通场景，通过 AI 生成定制化多语言话术及个性化策略指导，适配目标市场商务礼仪，解决传统沟通中 “模板化回复率低、跨文化误解多” 的痛点，提升与海外客户的沟通效率。',
      title2: '无障碍语言沟通，AI智能辅助沟通效率大幅度提升',
      platform: {
        list: [
          {
            title: `AI 智能邮件话术生成`,
            desc: '结合销售阶段及业务背景，根据不同阶段的销售难题，自动生成个性化邮件话术及指导意见',
          },
          {
            title: `多语种商务邮件翻译`,
            desc: '提供不仅在文字层面、 还包括对方文化中的商务交往习惯的多语言翻译',
          },
          {
            title: `便捷邮件模板`,
            desc: '支持预编辑多种常用的邮件模板，便捷发送',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '从“套用模板”到“定制化沟通”',
          desc: '区别于传统邮件工具的固定模板，AI 会结合业务阶段及客户情况生成个性化沟通内容',
        },
        {
          title: '不止“翻译文字”，更懂“当地逻辑”',
          desc: '区别于传统翻译工具仅做字面转换，AI商务邮件翻译能更好兼顾目标国家的商务习惯，避免词不达意',
        },
        {
          title: '经典成功话术沉淀',
          desc: '成功沟通案例自动存档，形成专属营销话术库，可在同类情况中直接复用，避免“重复踩坑”',
        },
      ],
      scene: [
        {
          title: '新客户破冰',
          desc: '用适配当地文化的邮件话术快速建立连接，提升初次沟通响应率',
        },
        {
          title: '需求跟进',
          desc: '针对客户疑问生成有效回应话术及思路，加速需求确认',
        },
        {
          title: '谈判推进',
          desc: '通过生成针对性的智能邮件话术打破谈判中的施压和挑战，缩短沟通周期',
        },
        {
          title: '难题化解',
          desc: '客户对价格、方案存疑或需求模糊时，AI 生成话术破僵局，推进合作',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '邮件回复率',
            },
            {
              label: '多语言沟通成本',
            },
            {
              label: '跨文化误解率',
            },
            {
              label: '沟通周期',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工模式',
            },
            {
              label: '低',
            },
            {
              label: '需各语种专业翻译，翻译成本高',
            },
            {
              label: '高',
            },
            {
              label: '长',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `高`,
            },
            {
              label: 'AI 智能生成，成本降低90%',
            },
            {
              label: '低',
            },
            {
              label: '短',
            },
          ]
        },
      ],
    },
    // 困境策略大师
    strategyCoach: {
      banner: {
        title: '困境策略大师',
        content: `破解各类出海销售困境及各阶段<br>话术指导，<span style="color: #1A64FE">破局成功率提升 >70%</span>`,
      },
      title1: 'Xpirory 困境策略大师',
      desc1: '针对企业服务及非标品出海的全销售阶段（破冰 / 竞品对比 / 价格谈判等），生成定制化策略与实战话术，结合跨文化商务习惯，打破沟通僵局。',
      title2: '困境策略大师，客户成功率提高50%-80%',
      platform: {
        list: [
          {
            title: `销售难题库`,
            desc: '共享不同销售阶段的各类销售难题，快速找到参考',
          },
          {
            title: `销售话术策略专家`,
            desc: '针对销售难题自动生成处理回复的方法和建议',
          },
          {
            title: `个性化指导`,
            desc: '深度结合企业信息和客户信息，定制企业专属的指导意见',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '聚焦ToB非标品业务',
          desc: '针对企业服务及非标定品业务决策链长，沟通环节多等业务痛点，提供不同阶段个性化的销售策略',
        },
        {
          title: '策略 + 话术双输出',
          desc: '不仅告诉你 “怎么做”，更告诉你“怎么说”',
        },
        {
          title: '跨文化谈判适配',
          desc: '结合目标市场习惯，优化语言策略，避免 “照搬国内经验” 导致的沟通失效',
        },
      ],
      scene: [
        {
          title: '需求模糊破局',
          desc: '深度分析客户多方面潜在需求，助力多维度主动出击',
        },
        {
          title: '竞品挑战攻坚',
          desc: '客户拿竞品压价：生成 “差异化价值拆解” 话术',
        },
        {
          title: '价格谈判拉锯',
          desc: '客户反复压价，针对性地提供破局谈判策略',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '困境响应时间',
            },
            {
              label: '破局成功率',
            },
            {
              label: '谈判周期',
            },
            {
              label: '利润保留率',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工模式',
            },
            {
              label: '2-3 天 <br/>（团队讨论 + 经验复盘）',
            },
            {
              label: '低',
            },
            {
              label: '长',
            },
            {
              label: '低',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `1分钟<br/>（AI 实时生成应对策略）`,
            },
            {
              label: '高',
            },
            {
              label: '短',
            },
            {
              label: '高',
            },
          ]
        },
      ],
    },
    // 隐私政策
    policy: {
      date: '生效日期：2025年4月7日',
      msg: '导言',
      msg1: 'Xpirory是由XPIRORY PTE. LTD.（以下简称“我们”）开发及运营的在线服务平台。您在使用我们的产品及服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》与您所使用的Xpirory产品及服务息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。本《隐私政策》中涉及的相关技术词汇，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您的理解。',
      msg2: '您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。',
      msg3: '如对本《隐私政策》或相关事宜有任何问题，请通过business development@xpirory.com与我们联系。',
      msg4: '1.我们收集的信息',
      msg5: '我们或我们的第三方合作伙伴提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。',
      msg6: '个人信息：您在注册账户或使用我们的服务时，向我们提供的相关个人信息，例如邮箱地址及其密码、用户名称、自定义的登录密码、手机号码、短信验证码等。',
      msg7: '位置信息：指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：',
      msg8: '您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息；',
      msg9: '您可以通过关闭定位功能，停止对您的地理位置信息的收集。',
      msg10: '相机权限或相册（存储）权限：为您提供图像上传/下载服务。我们不会主动调用上述权限，仅在您使用本应用过程中并授予上述权限后，我们会使用上述信息以记录您在本应用的使用情况。',
      msg11: '设备及连接信息：例如用户 IP 地址、浏览器类型及版本、设备信息等。',
      msg12: '日志信息，指您使用我们的服务时，系统可能通过cookies、标识符及相关技术收集的信息，包括您的设备信息、浏览信息、点击信息，并将该等信息储存为日志信息，为您提供个性化的用户体验、保障服务安全。您可以通过浏览器设置拒绝或管理cookie、标识符或相关技术的使用。',
      msg13: '内容发布/上传：当您使用我们的服务，发布、生成各类分析报告和方案时，我们会主动收集您提供的内容信息，包括但不限于企业介绍、主营业务、产品资料、方案资料、客户名称、客户邮箱、与客户的沟通记录、用于分析的地图文件、模拟对象的行为数据、模拟对象数量等。如您发布的内容中包括其他个人/企业的重要信息，请您务必取得其他个人/企业的合法授权，避免非法泄露其他个人/企业的信息。',
      msg14: '交易支付记录：我们使用的是stripe第三方的支付聚合工具。具体支付过程将由stripe处理，我们会收集第三方反馈给我们的关于您的第三方支付渠道的user ID、交易金额、交易时间、交易商户、交易状态等信息。为了保证您的支付行为安全，第三方支付渠道会获取您的设备信息。上述信息是为我们向您提供服务所必须的信息。',
      msg15: '维护/改进我们服务之必须：为了保障您的账号与系统安全，防止恶意程序及反作弊、反欺诈，收集bug以及维护/改进我们服务。我们可能需要收集您的一些信息，包括：设备信息、上网记录、获取粘贴板信息、服务日志信息、账户及实名认证信息，及经您授权后我们从我们的关联公司、合作伙伴处收集的信息。',
      msg16: '其他信息：当您浏览、点击、搜索、查看、使用本服务时所产生的用户记录，我们会收集您的使用情况，作为服务网络日志保存。若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。',
      msg17: '2. 信息的存储',
      msg18: '2.1 信息存储的方式和期限',
      msg19: '我们会通过安全的方式存储您的信息，包括本地存储（例如利用APP进行数据缓存）、数据库和服务器日志。',
      msg20: '一般情况下，我们只会在为实现服务目的所必需的时间内或法律法规规定的条件下存储您的个人信息。',
      msg21: '2.2 信息存储的地域',
      msg22: '我们会按照法律法规规定，将境内收集的用户个人信息存储于新加坡境内。当您使用特定功能（例如跨境支付）时可能通过第三方服务（如Stripe、Google）传输至美国、欧盟等地。我们确保传输符合标准合同条款（SCCs）或等效机制。',
      msg23: '2.3 产品或服务停止运营时的通知',
      msg24: '当我们的产品或服务发生停止运营的情况时，我们将以推送通知、公告等形式通知您，并在合理期限内删除您的个人信息或进行匿名化处理，法律法规另有规定的除外。',
      msg25: '3.信息安全',
      msg26: '我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术（例如SSL）来保护您提供的个人信息。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。',
      msg27: '4.我们如何使用信息',
      msg28: '我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：',
      msg29: '向您提供服务，包括身份验证、客户服务、安全防范、诈骗监测、存档和备份用途等场景，确保我们向您提供的产品和服务的安全性；',
      msg30: '与授权合作第三方共享。如经您合法授权，我们会与第三方分享您的个人信息，我们仅会处于合法、正当、必要、特定、明确的目的与第三方共享必要的个人信息，并适时采取加密、匿名化等手段保证您的信息安全。',
      msg31: '帮助我们设计新服务，改善我们现有服务；',
      msg32: '使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应；',
      msg33: '向您提供与您更加相关的广告以替代普遍投放的广告；',
      msg34: '评估我们服务中的广告和其他促销及推广活动的效果，并加以改善；',
      msg35: '软件认证或管理软件升级；',
      msg36: '让您参与有关我们产品和服务的调查。',
      msg37: '数据使用目的及法律依据：',
      msg38: '用途',
      msg39: '数据类型',
      msg40: '法律依据（GDPR）',
      msg41: '账户管理及服务履行',
      msg42: '邮箱、用户名称',
      msg43: '合同履行必要性',
      msg44: '支付处理',
      msg45: '支付信息',
      msg46: '合同履行',
      msg47: '服务优化与个性化推荐',
      msg48: '偏好设置、地理位置',
      msg49: '基于用户同意（通过Cookie授权弹窗获取）',
      msg50: '安全风控与反欺诈',
      msg51: 'IP地址、设备信息',
      msg52: '',
      msg53: '合法权益',
      msg54: '5.信息共享',
      msg55: '目前，我们不会主动共享或转让您的个人信息至第三方，除了部分为满足平台功能和业务开展的第三方合作方。当前已有的第三方合作方包括：',
      msg56: '支付处理商：Stripe、微信支付、支付宝。',
      msg57: '分析工具：Google Analytics（匿名化数据，禁用用户ID共享）。',
      msg58: '广告平台：Google Ads（遵守其数据使用政策）。',
      msg59: '为了投放广告，评估、优化广告投放效果等目的，我们需要向Google等第三方合作伙伴共享经去标识化处理的用户行为数据，要求其严格遵守我们关于数据隐私保护的措施与要求，包括但不限于根据数据保护协议、承诺书及相关数据处理政策进行处理，避免识别出个人身份，保障隐私安全。',
      msg60: '我们不会向合作伙伴分享可用于识别您个人身份的信息（例如您的姓名或电子邮件地址），除非您明确授权。',
      msg61: '我们不会对外公开披露所收集的个人信息，如必须公开披露时，我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明示同意。',
      msg62: '随着我们业务的持续发展，我们有可能进行合并、收购、资产转让等交易，我们将告知您相关情形，按照法律法规及不低于本《隐私政策》所要求的标准继续保护或要求新的控制者继续保护您的个人信息。',
      msg63: '另外，根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得您的授权同意：',
      msg64: '为订立、履行您作为一方当事人的合同所必需，或者为履行我们的法定职责或者法定义务所必需；',
      msg65: '与公共安全、公共卫生、重大公共利益直接相关的；',
      msg66: '犯罪侦查、起诉、审判和判决执行等直接相关的；',
      msg67: '个人信息主体自行向社会公众公开个人信息的；',
      msg68: '从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；',
      msg69: '法律、行政法规规定的其他情形。',
      msg70: '6.您的权利',
      msg71: '在您使用我们的服务期间，我们可能会视产品具体情况为您提供相应的操作设置，以便您可以查询、删除、更正或撤回您的相关个人信息，您可参考相应的具体指引进行操作。此外，我们还设置了投诉举报渠道，您的意见将会得到及时的处理。如果您无法通过上述途径和方式行使您的个人信息主体权利，您可以通过本《隐私政策》中提供的联系方式提出您的请求，我们会按照法律法规的规定予以反馈。',
      msg72: '当您决定不再使用我们的产品或服务时，可以申请注销账户。注销账户后，除法律法规另有规定外，我们将删除或匿名化处理您的个人信息。',
      msg73: '7.儿童隐私',
      msg74: '我们不收集16岁以下儿童的信息，如果您发现任何 16 岁以下的人员非法向我们提供了个人数据，请与我们联系，我们将采取措施删除此类信息。',
      msg75: '8.变更',
      msg76: '我们可能适时修订本《隐私政策》的条款。当变更发生时，我们会在版本更新时向您提示新的《隐私政策》，并向您说明生效日期。请您仔细阅读变更后的《隐私政策》内容，若您继续使用我们的服务，即表示您同意我们按照更新后的《隐私政策》处理您的个人信息。',
    },
    // 使用条款
    useTerms: {
      date: '生效日期：2025年4月7日',
      msg1: 'XPIRORY PTE. LTD.（以下简称“Xpirory”）已更新适用于我方网站的使用条款。就本使用条款而言，“网站”统指Xpirory官方网站（www.xpirory.com）以及Xpirory运营且链接至本条款的所有其他网站。',
      msg2: '我们根据本《使用条款》（以下简称“条款”）向您提供网站服务，我们可能根据下文第1节的规定不时更新本条款。您访问或使用网站即表示接受并同意受本条款、Xpirory隐私声明及Xpirory Cookie政策的约束。若您不同意本条款，则不应访问或使用网站。此外，访问网站时，您应遵守网站上发布的任何适用规则或指南，此类规则或指南可能随时更新并纳入本条款。',
      msg3: '我们如何保护、收集和使用您提交并存储于服务中的电子数据、文本或其他材料（即“服务数据”）的实践与政策，详见隐私政策。',
      msg4: '1. 条款修改',
      msg5: '我们可随时修改本条款的任何部分，包括增删条款，修改内容将在发布后立即生效。您在发布后继续使用网站即视为接受该等修改。',
      msg6: '2. 网站变更',
      msg7: '我们可随时更改或终止网站的任何功能、服务或内容，包括但不限于内容、可用性及访问所需的设备。',
      msg8: '3. 注册',
      msg9: '您可能通过在线注册创建用户账户（“您的账户”），以使用网站特定功能。我们将根据隐私声明使用您提供的信息。注册时，您声明并保证所提供的信息在当前情况下真实、完整且准确。您同意及时更新网站信息以保持其真实性与完整性，并自行承担访问和使用网站所需的软硬件设备及相关费用。',
      msg10: '4. 用户内容准则',
      msg11: '以下条款适用于您提交的内容：',
      msg12: '4.1 网站包含信息查询、文件上传、文本输入等功能，您可在其中输入或上传用户自有文本内容、图片、文档等材料（统称“用户内容”）。您需对使用这部分功能的行为承担全部责任，且使用风险自担。网站功能仅对16岁及以上用户开放。提交用户内容即表示您声明自己年满16周岁；若未满18周岁，您需取得父母或法定监护人的合法同意。',
      msg13: '4.2 通过网站提交用户内容时，您同意不上传、发布或传播以下内容：',
      msg14: '(a) 侵犯他人权利（包括诽谤、骚扰、跟踪或威胁他人的言论）；',
      msg15: '(b) 您明知虚假、误导或不准确的内容；',
      msg16: '(c) 包含明显偏见、种族主义、种族或民族攻击性内容、仇恨言论、辱骂、低俗或脏话；',
      msg17: '(d) 含有或宣扬色情、性露骨内容、恋童癖、乱伦、兽交或其他淫秽内容；',
      msg18: '(e) 违反法律、教唆危险/非法/掠夺行为，或意图实施非法活动的讨论；',
      msg19: '(f) 宣扬暴力行为；',
      msg20: '(g) 对个人或公共安全构成合理威胁；',
      msg21: '(h) 以剥削、色情或不当目的为主展示杀戮或身体虐待的暴力图像；',
      msg22: '(i) 未经权利人明示许可，使用受版权、商标、商业秘密、肖像权或其他专有权利保护的内容；',
      msg23: '(j) 包含未经请求的广告、“垃圾邮件”、“链式信件”、“传销”等推广内容；',
      msg24: '(k) 未经许可使用可识别自然人的姓名或肖像；',
      msg25: '(l) 其他法律法规禁止的内容。',
      msg26: '您需对侵权行为导致的损害承担全部责任。Xpirory有权禁止违规用户继续提交内容。',
      msg27: '4.3 您不得暗示Xpirory对用户内容的认可。',
      msg28: '4.4 您不得上传含病毒或破坏性组件的用户内容。',
      msg29: '4.5 我们对用户内容的准确性不负责，由此产生的使用风险用户自担。',
      msg30: '5. 用户行为准则',
      msg31: '您同意：',
      msg32: '(a) 不干扰网站或相关网络的正常运行；',
      msg33: '(b) 不为商业目的复制、出售或利用网站内容；',
      msg34: '(c) 不从事非法活动；',
      msg35: '(d) 不冒充Xpirory或员工；',
      msg36: '(e) 不侵犯他人隐私。',
      msg37: '6. 知识产权',
      msg38: '网站上的所有文本、图形、商标、软件等内容均为Xpirory所有或授权使用，受版权、商标法等保护。未经书面许可，不得以任何形式复制、传播网站内容，个人非商业用途且保留权利声明的情况除外。',
      msg39: '7. 免责声明及责任限制',
      msg40: '(A) 使用网站风险自担。Xpirory不保证网站无中断或错误。',
      msg41: '(B) 网站按“现状”提供，不提供任何明示或默示担保（法律强制要求的除外）。',
      msg42: '(C) 在法律允许的最大范围内，Xpirory不对因使用网站导致的直接、间接、附带或后果性损害（包括数据丢失、商誉损失等）承担责任。',
      msg43: '(D) 我们对未经授权访问您的个人信息不承担责任。',
      msg44: '8. 终止与暂停',
      msg45: '我们可随时终止或暂停您对网站的访问，且不承担通知义务。',
      msg46: '9. 版权与版权代理人',
      msg47: '若认为网站内容侵犯版权，请根据Xpirory版权侵权通知及下架政策提交报告。',
      msg48: '10. 数字服务法（DSA）',
      msg49: '根据欧盟DSA，若您需举报违规内容，请联系我们。欧盟委员会、成员国当局及数字服务委员会可通过business development@xpirory.com联系我们。',
    }
  },
  ...zhLocale,
};

export default cn;
